import React, { useState } from 'react';
import ActionBar from '../layout/ActionBar';
import { hasPermission } from '../auth/authUtils';
import permissionTypes from '../../constants/permissionTypes';
import SlidingPane from 'react-sliding-pane';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';
import GameFranchiseList from './components/GameFranchiseList';
import GameFranchise from './slideout/GameFranchise';
import DeleteGameFranchise from './slideout/DeleteGameFranchise';
import { GameFranchiseModel } from '../../types/swagger-dtos/GamesDtos';

function GameFranchises() {
  const { t } = useTranslation();
  usePageTitle(['Game Franchises']);
  const currentUser = useAppSelector((state) => state.auth);
  const [reload, setReload] = useState<Date>(new Date());
  const [gameFranchiseSlideoutOpen, setGameFranchiseSlideoutOpen] = useState(false);
  const [editGameFranchise, setEditGameFranchise] = useState<GameFranchiseModel | null>(null);
  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);

  return (
    <>
      <ActionBar>
        {hasPermission(currentUser, permissionTypes.MANAGE_GAMES) && (
          <Button
            className="btn btn-primary me-2"
            onClick={() => { setGameFranchiseSlideoutOpen(true); setEditGameFranchise(null); }}
            text={t('Add game franchise')}
            testId="add-game-franchise-button"
          />
        )}
      </ActionBar>

      <GameFranchiseList
        reload={reload}
        editGameFranchise={(gameFranchise: GameFranchiseModel) => {
          setEditGameFranchise(gameFranchise);
          setGameFranchiseSlideoutOpen(true);
        }}
      />

      <SlidingPane
        isOpen={gameFranchiseSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setGameFranchiseSlideoutOpen(false)}
      >
        <GameFranchise
          gameFranchise={editGameFranchise}
          cancel={() => setGameFranchiseSlideoutOpen(false)}
          done={() => {
            setGameFranchiseSlideoutOpen(false);
            setReload(new Date())
          }}
          handleDelete={() => setDeleteSlideoutOpen(true)}></GameFranchise>
      </SlidingPane>

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteGameFranchise
          id={editGameFranchise?.id || ''}
          done={() => {
            setDeleteSlideoutOpen(false);
            setGameFranchiseSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default GameFranchises;
